import React from "react";

const ImpressumDe = () => {
  return (
    <main className="video-page">
      <section className="section" style={{ paddingTop: "clamp(7rem, 12vw, 10rem)" }}>
        <div className="container-narrow prose-body">
          <h1 style={{ fontSize: "clamp(2.2rem, 4vw, 3rem)", marginBottom: "2rem" }}>Impressum</h1>

          <p style={{ marginBottom: 0 }}>
            <strong>Dr. Ing. Luca Pizzimbone</strong>
            <br />
            Homburger Str. 31
            <br />
            61184 Karben
            <br />
            Deutschland
          </p>

          <p style={{ marginTop: "1.5rem" }}>
            E-Mail:{" "}
            <a href="mailto:info@nonlocalfield.io">info@nonlocalfield.io</a>
          </p>

          <p style={{ marginTop: "1.5rem" }}>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
            bereit, die du hier findest:{" "}
            <a
              href="https://ec.europa.eu/consumers/odr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://ec.europa.eu/consumers/odr/
            </a>
            . Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor
            einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>

          <h2 style={{ fontSize: "clamp(1.5rem, 3vw, 2rem)", margin: "2.5rem 0 1.25rem" }}>
            Gesundheits- und rechtlicher Hinweis
          </h2>
          <p>
            Gemäß der Entscheidung des Bundesverfassungsgerichts (BVerfG), 1 BvR 784/03, dienen die
            Angebote der Nichtlokalen Feldharmonisierung (NLFH) und des energetischen Raumhaltens
            ausschließlich der Unterstützung der angeborenen Selbstregulation. Sie stellen keine
            medizinische, heilpraktische oder psychotherapeutische Behandlung dar und ersetzen nicht
            die Diagnose oder Behandlung durch einen approbierten Arzt, Chirurgen oder Psychotherapeuten.
            Es werden keine Heilversprechen oder spezifischen Gesundheitsergebnisse zugesichert und keine
            medizinischen Diagnosen gestellt. Bitte verzögere, unterbrich, verändere oder beende keine
            laufende medizinische Behandlung, Therapie oder verordnete Medikation, ohne zuvor deinen
            behandelnden Arzt zu konsultieren.
          </p>
          <p style={{ marginTop: "1.5rem" }}>
            Innerhalb dieser Grenze besteht der alleinige Zweck von NLFH darin, eine Umgebung somatischer
            Sicherheit, Herzkohärenz und weiten Gewahrseins zu kultivieren — und damit deine Beziehung zur
            herkömmlichen medizinischen und psychotherapeutischen Versorgung sowie zu den approbierten
            Fachkräften, die sie erbringen, zu unterstützen, niemals zu ersetzen.
          </p>
        </div>
      </section>
    </main>
  );
};

export default ImpressumDe;
